import { Activity, AlertTriangle, CheckCircle2 } from 'lucide-react';
import type { CustomLlmEndpointRow, HealthItem } from './types';

interface Props {
  endpoint: CustomLlmEndpointRow;
  history: HealthItem[];
}

function StatusIcon({ status }: { status: string }): JSX.Element {
  if (status === 'ok') return <CheckCircle2 className="h-4 w-4 text-emerald-600" />;
  if (status === 'degraded') return <AlertTriangle className="h-4 w-4 text-amber-600" />;
  return <AlertTriangle className="h-4 w-4 text-rose-600" />;
}

export function HealthCard({ endpoint, history }: Props): JSX.Element {
  const last = endpoint.last_probe_at
    ? new Date(endpoint.last_probe_at).toLocaleString('it-IT')
    : 'mai';
  return (
    <div className="rounded-lg border border-zinc-200 bg-white p-3 dark:border-zinc-700 dark:bg-zinc-900">
      <div className="mb-2 flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-medium">
          <Activity className="h-4 w-4" />
          Stato endpoint
        </div>
        <span
          className={`rounded-full px-2 py-0.5 text-xs font-semibold ${
            endpoint.health_status === 'ok'
              ? 'bg-emerald-100 text-emerald-700'
              : endpoint.health_status === 'degraded'
                ? 'bg-amber-100 text-amber-700'
                : endpoint.health_status === 'down'
                  ? 'bg-rose-100 text-rose-700'
                  : 'bg-zinc-100 text-zinc-700'
          }`}
        >
          {endpoint.health_status}
        </span>
      </div>
      <div className="text-xs text-zinc-500">
        Ultima probe: {last} · Failures consecutive: {endpoint.consecutive_failures}
      </div>
      {history.length > 0 && (
        <ul className="mt-3 space-y-1">
          {history.slice(0, 5).map((h, i) => (
            <li
              key={`${h.probed_at}-${i}`}
              className="flex items-center justify-between gap-2 rounded border border-zinc-100 px-2 py-1 text-xs dark:border-zinc-800"
            >
              <span className="flex items-center gap-1.5">
                <StatusIcon status={h.status} />
                <span className="font-medium">{h.probe_kind}</span>
                <span className="text-zinc-500">
                  {h.http_status ?? '—'} · {h.latency_ms ?? '?'}ms
                </span>
              </span>
              <span className="text-zinc-400">
                {new Date(h.probed_at).toLocaleTimeString('it-IT')}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
